// Query factories must include a deterministic, unique ordering.
export const fetchAllRows = async (buildQuery, pageSize = 1000) => {
  const rows = [];
  for (let offset = 0; ; offset += pageSize) {
    const { data, error } = await buildQuery().range(offset, offset + pageSize - 1);
    if (error) throw error;
    rows.push(...(data || []));
    if (!data || data.length < pageSize) return rows;
  }
};
